import React, { useState } from "react";
import { Button, Input, Modal } from "antd";
import style from "./index.module.scss";
import { errorMessage } from "Utils/useRequest";
import { ResultMessage } from "components/ResultMessage";
import icon from "./img/icon.png";
import {
    getCourseInfoByJoinInCode,
    stuCourseJoinInByCode
} from "API/invitationCode";

interface AddModalProps {
    onCancel: () => void;
    onOk: () => void;
    batch: string;
}

export default function AddModal({ onCancel, onOk, batch }: AddModalProps) {
    const [code, setCode] = useState("");
    const [error, setError] = useState(""); // 错误状态

    const handleSearch = async function () {
        if (!checkData()) return;
        try {
            const info = await getCourseInfoByJoinInCode(code?.trim());
            onCancel();
            handleAdd(info.courseName, info.teacherName);
        } catch (e) {
            setError(errorMessage(e));
        }
    };

    // 检查数据
    function checkData(): boolean {
        if (code?.trim().length === 0) {
            setError("请输入邀请码");
            return false;
        }
        return true;
    }

    const handleAdd = async function (courseName: string, teacherName: string) {
        Modal.confirm({
            title: `确认加入该课程吗？`,
            content: (
                <div className={style.modal}>
                    <p>课程名称：{courseName}</p>
                    <p>授课教师：{teacherName}</p>
                </div>
            ),
            okText: "确认加入",
            cancelText: "不加入",
            onOk: async () => {
                try {
                    await stuCourseJoinInByCode(code);
                    ResultMessage.success("成功加入课程");
                    onOk();
                    onCancel();
                    handleClose();
                } catch (e) {
                    ResultMessage.error(errorMessage(e));
                }
            }
        });
    };

    //关闭时清空表单
    function handleClose() {
        onCancel();
        setCode("");
    }

    return (
        <div className={style.root}>
            <div className={style.container}>
                <div className={style.top}>
                    <div className={style.title}>
                        <img src={icon} className={style.icon} />
                        输入课程邀请码
                    </div>
                    <Input
                        value={code}
                        onChange={e => setCode(e.target.value)}
                    />
                    <div className={style.error}>{error}</div>
                </div>

                <div className={style.footer}>
                    <Button onClick={onCancel}>取消</Button>
                    <Button type="primary" onClick={handleSearch}>
                        查找
                    </Button>
                </div>
            </div>
        </div>
    );
}
